import Head from "next/head";
import { Body } from "components/aud/base/Body";

export const SimplePageLayout = ({ children, bodyProps: { noPadding = true, ...restBodyProps } = {} }) => {
  return (
    <Body {...restBodyProps} noPadding={noPadding}>
      <Head>
        <link rel="icon" href="/images/favicon.ico" />
      </Head>

      {children}
    </Body>
  );
};
